import { useEffect, useState } from "react";

/**
 * THE THRESHOLD — load reveal.
 * Two dark panels meet at a gold seam. After a beat they part with vault easing.
 * Plays once per session. Skipped for prefers-reduced-motion.
 */
export default function Threshold() {
  const [mounted, setMounted] = useState(false);
  const [open, setOpen] = useState(false);
  const [gone, setGone] = useState(false);

  useEffect(() => {
    if (typeof window === "undefined") return;
    const reduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    const played = sessionStorage.getItem("ca:threshold:v1") === "1";
    if (reduced || played) return;
    sessionStorage.setItem("ca:threshold:v1", "1");

    document.body.style.overflow = "hidden";
    setMounted(true);

    const t1 = setTimeout(() => setOpen(true), 650);
    const t2 = setTimeout(() => {
      setGone(true);
      document.body.style.overflow = "";
    }, 650 + 1400 + 200);
    return () => {
      clearTimeout(t1); clearTimeout(t2);
      document.body.style.overflow = "";
    };
  }, []);

  if (!mounted || gone) return null;

  return (
    <div
      aria-hidden
      className="fixed inset-0 z-[9999] pointer-events-none"
      style={{ opacity: gone ? 0 : 1 }}
    >
      {/* Left panel */}
      <div
        className="absolute inset-y-0 left-0 w-1/2"
        style={{
          background: "#070605",
          transform: open ? "translateX(-101%)" : "translateX(0)",
          transition: "transform 1.4s cubic-bezier(0.76, 0, 0.24, 1)",
        }}
      />
      {/* Right panel */}
      <div
        className="absolute inset-y-0 right-0 w-1/2"
        style={{
          background: "#070605",
          transform: open ? "translateX(101%)" : "translateX(0)",
          transition: "transform 1.4s cubic-bezier(0.76, 0, 0.24, 1)",
        }}
      />
      {/* Gold seam */}
      <div
        className="absolute inset-y-0 left-1/2 -translate-x-1/2"
        style={{
          width: open ? "3px" : "1px",
          background:
            "linear-gradient(180deg, transparent 0%, #c9a86b 18%, #e5c883 50%, #c9a86b 82%, transparent 100%)",
          boxShadow: open
            ? "0 0 60px 10px rgba(229,200,131,0.6), 0 0 120px 30px rgba(201,168,107,0.4)"
            : "0 0 14px 1px rgba(201,168,107,0.35)",
          opacity: open ? 0 : 1,
          transition:
            "opacity 1.2s cubic-bezier(0.76, 0, 0.24, 1), box-shadow 1.2s ease-out, width 0.4s ease-out",
        }}
      />
      {/* Center monogram */}
      <div
        className="absolute inset-0 flex flex-col items-center justify-center gap-5"
        style={{
          opacity: open ? 0 : 1,
          transition: "opacity 0.7s cubic-bezier(0.76, 0, 0.24, 1)",
        }}
      >
        <div
          style={{
            fontFamily: "'Fraunces', serif",
            fontVariationSettings: "'opsz' 144, 'SOFT' 60",
            fontStyle: "italic",
            fontWeight: 400,
            fontSize: "clamp(4rem, 9vw, 7rem)",
            lineHeight: 1,
            color: "#e5c883",
            letterSpacing: open ? "0.4em" : "-0.02em",
            transition: "letter-spacing 1.4s cubic-bezier(0.76, 0, 0.24, 1)",
            textShadow: "0 0 40px rgba(201,168,107,0.35)",
          }}
        >
          CA
        </div>
        <span
          style={{
            fontFamily: "'JetBrains Mono', monospace",
            fontSize: "10.5px",
            letterSpacing: "0.42em",
            textTransform: "uppercase",
            color: "#8c764a",
          }}
        >
          Private Access System
        </span>
      </div>
    </div>
  );
}
